import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  settings;
  constructor(private httpService: HttpService) { }

  getSettings(){
    return this.httpService.get('setting');
  }
  setSettings(value){
    this.settings = value;
  }
  getLocalSettings(){
    return this.settings;
  }
  saveSettings(obj){
    return this.httpService.post('setting', obj);
  }
}
